export default "__VITE_ASSET__CY3j6m_C__"